<template>
    <div class="commentry-sec" v-if="config?.announcement?.value">
        <div class="commentry-fixed-img">
            <img loading="lazy" src="@/assets/images/commentary.webp" alt="commentary">
        </div>
        <div class="moving-text">
            <marquee>{{ config?.announcement?.value }}</marquee>
        </div>
    </div>
   <router-view v-if="init" :key="$route.fullPath"></router-view>
</template>

<script>

import { computed } from 'vue';
import { getWalletAuth} from '../services/module.js';
export default {
    name: "WalletModule",
    data() {
        return {
            init: false,
            historyCallInterval: null,
            config: null,
        }
    },
    provide() {
        return {
            walletConfig : computed(() => this.config),
        }
    },
    created() {
        if(!this.$auth?.user?.isDemo){
            this.getWalletAuth();
        }else{
            this.$errorToast('Wallet access is restricted for demo users')
            this.$router.push({name:'Home'})
        }
    },
    methods: {
        async getWalletAuth() {
            try {
                let response = await getWalletAuth();
                if(response?.data){
                    this.config = response.data
                    this.init = true
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
    }
}
</script>